import { IpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import type {
  GraphView,
  GraphViewRequestBody,
  GraphViewResponseBody,
} from '@ipfabric/utils';
import { fetchViews } from 'components/Graph/commands/fetchViews';
import { exitTopologyPresetEditMode } from 'components/Graph/commands/settings/exitTopologyPresetEditMode';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { createGraphViewRequestBody } from './viewHelpers/createGraphViewRequestBody';

// Expects name to create new view or view to update it
export interface SaveViewCommand {
  name?: string;
  view?: GraphView;
}

export const saveView: GraphCommandFactory<SaveViewCommand> =
  (cmdContext, dispatch) => async (command) => {
    if (!command.view && !command.name) {
      throw new IpfError(
        'INVALID_ARGUMENT',
        'you have to pass view or name to saveView',
      );
    }

    dispatch(exitTopologyPresetEditMode);

    const url = command.view
      ? `/graphs/views/${command.view.id}`
      : '/graphs/views';
    const method = command.view ? 'PUT' : 'POST';
    // we already checked that one of name or view is present so assertion is only to calm down TS
    const name = command.name ? command.name : (command.view?.name as string);

    if (!cmdContext.graphAppHandleRef.current) {
      throw new Error(
        'Cannot generate a view screenshot without a graph app handle',
      );
    }

    const preview =
      cmdContext.graphAppHandleRef.current.generateBase64Screenshot();

    const savedView = await cmdContext.api.request<
      GraphViewResponseBody,
      GraphViewRequestBody
    >({
      url,
      method,
      data: {
        ...createGraphViewRequestBody(name, cmdContext.getState()),
        preview,
      },
    });

    await dispatch(fetchViews);

    cmdContext.updateState((draft) => {
      draft.loadViewDialog.loadedView = savedView;
    });

    cmdContext.showNotification({
      type: 'success',
      message: cmdContext.msg.canvasGraph.commands.saveView.savedSuccessfully,
    });
  };
